// extracted by mini-css-extract-plugin
export default {"link":"SidebarLink--link--961a5b","isSelected":"SidebarLink--isSelected--52f47a","selected":"SidebarLink--selected--3a57fc","icon":"SidebarLink--icon--16c89b"};